import React, {FC} from 'react';
import {SubTitle} from "../components/SubTitle";
import {TextContainer} from "../components/TextContainer";

export const PrivacyPolicyPage: FC = () => {
    return (
        <TextContainer>
            <p>
                <SubTitle>Privacy Policy</SubTitle>
                I built the Team-Shuffle app as a Free app. This app is provided by me at no cost and is intended
                for use as is. This page is used to inform visitors regarding my policies with the collection, use, and
                disclosure of Personal Information if anyone decided to use my app. If you choose to use my app,
                then you agree to the collection and use of information in relation to this policy. The Personal
                Information that I collect is used for providing and improving the app. I will not use or share your
                information with anyone except as described in this Privacy Policy.
            </p>
            <br/>
            <p>
                <SubTitle>Information Collection and Use</SubTitle>
                For a better experience, while using my app, I may require you to provide me with certain
                personally identifiable information. The information that I request will be retained on your
                device and is not collected by me in any way. The app does use third-party services that may
                collect information used to identify you. Link to the privacy policy of third-party service
                providers used by the app:
            </p>
            <ul className="list-disc list-inside pt-1">
                <li>
                    <a href="https://expo.io/privacy" target="_blank" rel="noopener noreferrer">Expo</a>
                </li>
            </ul>
            <br/>
            <p>
                <SubTitle>Log Data</SubTitle>
                I want to inform you that whenever you use my app, in a case of an error in the app I
                collect data and information (through third-party products) on your phone called Log Data. This
                Log Data may include information such as your device Internet Protocol (“IP”) address, device
                name, operating system version, the configuration of the app when utilizing my app, the time
                and date of your use of the app, and other statistics.
            </p>
            <br/>
            <p>
                <SubTitle>Cookies</SubTitle>
                Cookies are files with a small amount of data that are commonly used as anonymous unique
                identifiers. These are sent to your browser from the websites that you visit and are
                stored on your device's internal memory. This app does not use these “cookies” explicitly.
                However, the app may use third-party code and libraries that use “cookies” to collect
                information and improve their services.
            </p>
            <br/>
            <p><SubTitle>Service Providers</SubTitle></p>
            <p>
                I may employ third-party companies and individuals due to the following reasons:
            </p>
            <ul className="list-disc list-inside py-1">
                <li>To facilitate my app</li>
                <li>To provide the app on my behalf</li>
                <li>To perform app related services or</li>
                <li>To assist me in analyzing how my app is used</li>
            </ul>
            <p>
                I want to inform users of this app that these third parties have access to their Personal
                Information. The reason is to perform the tasks assigned to them on my behalf. However, they
                are obligated not to disclose or use the information for any other purpose.
            </p>
            <br/>
            <p>
                <SubTitle>Links to Other Sites</SubTitle>
                This site may contain links to other sites. If you click on a third-party link, you will be
                directed to that site. Note that these external sites are not operated by me. Therefore, I
                strongly advise you to review the Privacy Policy of these websites. I have no control over and
                assume no responsibility for the content, privacy policies, or practices of any third-party
                sites or services.
            </p>
            <br/>
            <p>
                <SubTitle>Changes to This Privacy Policy</SubTitle>
                I may update this Privacy Policy from time to time. Thus, you are advised to review this page
                periodically for any changes. I will notify you of any changes by posting the new Privacy Policy
                on this page. This policy is effective as of 2022-11-26
            </p>
            <br/>
            <p>
                <SubTitle>Contact Us</SubTitle>
                If you have any questions or suggestions about my Privacy Policy, do not hesitate to contact me
                at team.shuffle.app@gmail.com.
            </p>
        </TextContainer>
    );
};
